import { getTaxAdviceBuyButtonConfig } from '../utils/taxEntitlements';

export const TAX_ADVICE_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.taxAdvice.buyBox.bulletPoint5' },
        { title: 'productPage.taxAdvice.buyBox.bulletPoint6' },
        { title: 'productPage.taxAdvice.buyBox.bulletPoint7' }
      ],
      packageName: 'productPage.taxAdvice.optionLabel.option1',
      productName: 'productPage.taxAdvice.buyBox.productName1',
      interactService: {
        ctaType: 'internalCheckout',
        isPurchasedByOrderTask: true,
        service: 'zb_tax_advice'
      }
    },
    {
      bulletPoints: [
        { title: 'productPage.taxAdvice.buyBox.bulletPoint1' },
        { title: 'productPage.taxAdvice.buyBox.bulletPoint2' },
        { title: 'productPage.taxAdvice.buyBox.bulletPoint3' },
        { title: 'productPage.taxAdvice.buyBox.bulletPoint4' }
      ],
      packageColor: 'palette.background.green.main',
      packageName: 'productPage.taxAdvice.optionLabel.option2',
      productName: 'productPage.taxAdvice.buyBox.productName2',
      packageNote: 'productPage.taxAdvice.optionLabel.option2Callout',
      interactService: {
        ctaType: 'internalCheckout',
        isPurchasedByOrderTask: true,
        service: 'zb_tax_advice_biztax_prep'
      }
    }],
    headerPicture: {
      src: '/s2/raster/laptop-plant-desk.png',
      alt: 'productPage.taxAdvice.heroPicture.altText'
    },
    comparePackages: 'productPage.taxAdvice.buyBox.comparePackages',
    plans: {
      title: 'productPage.taxAdvice.compareModal.title',
      items: [
        {
          name: 'productPage.taxAdvice.compareModal.product1Name',
          service: 'tax_unlimited_advice',
          features: [
            'productPage.taxAdvice.compareModal.product1Bullet1',
            'productPage.taxAdvice.compareModal.product1Bullet2',
            'productPage.taxAdvice.compareModal.product1Bullet3'
          ],
          tag: null,
          icon: null
        },
        {
          name: 'productPage.taxAdvice.compareModal.product2Name',
          service: 'tax_annual_filing',
          features: [
            'productPage.taxAdvice.compareModal.product2Bullet1',
            'productPage.taxAdvice.compareModal.product2Bullet2',
            'productPage.taxAdvice.compareModal.product2Bullet3',
            'productPage.taxAdvice.compareModal.product2Bullet4',
            'productPage.taxAdvice.compareModal.product2Bullet5',
            'productPage.taxAdvice.compareModal.product2Bullet6',
            'productPage.taxAdvice.compareModal.product2Bullet7',
            'productPage.taxAdvice.compareModal.product2Bullet8',
            'productPage.taxAdvice.compareModal.product2Bullet9',
            'productPage.taxAdvice.compareModal.product2Bullet10',
            'productPage.taxAdvice.compareModal.product2Bullet11'
          ],
          tag: {
            label: 'productPage.taxAdvice.optionLabel.option2Callout',
            color: 'palette.secondary.light'
          }
        }
      ]
    },
    headline: 'productPage.taxAdvice.page.headline',
    partnerLogo: {
      src: '/logo/1800accountant-logo.png',
      alt: ''
    },
    partnerReviewBlanks: [
      {
        text: 'productPage.legalShield.page.reviewText1'
      },
      {
        src: '/illustration/trustpilot-4.5-star.svg',
        showOnMobile: true,
        alt: ''
      },
      {
        src: '/illustration/trustpilot-logo.svg',
        alt: ''
      }
    ],
    subheader: 'productPage.taxAdvice.page.subheader'
  },
  benefit: {
    title: 'productPage.taxAdvice.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.taxAdvice.valueProp.propTitle1',
        description: 'productPage.taxAdvice.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/todayrounded.svg',
        title: 'productPage.taxAdvice.valueProp.propTitle2',
        description: 'productPage.taxAdvice.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/supportrounded.svg',
        title: 'productPage.taxAdvice.valueProp.propTitle3',
        description: 'productPage.taxAdvice.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/moneyoffrounded.svg',
    title: 'productPage.taxAdvice.topFeature.title',
    subheader: 'productPage.taxAdvice.topFeature.subheader',
    image: '/s2/raster/barista-smiling-watch.png',
    alt: 'productPage.taxAdvice.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.taxAdvice.howItWorks.title',
    items: [
      {
        title: 'productPage.taxAdvice.howItWorks.step1',
        description: 'productPage.taxAdvice.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.taxAdvice.howItWorks.step2',
        description: 'productPage.taxAdvice.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.taxAdvice.howItWorks.step3',
        description: 'productPage.taxAdvice.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/phone-livingroom-laptop.png',
    alt: 'productPage.taxAdvice.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.taxAdvice.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.taxAdvice.frequentlyAskedQuestions.faq1',
        answer: 'productPage.taxAdvice.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.taxAdvice.frequentlyAskedQuestions.faq2',
        answer: 'productPage.taxAdvice.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.taxAdvice.frequentlyAskedQuestions.faq3',
        answer: 'productPage.taxAdvice.frequentlyAskedQuestions.faqAnswer3'
      },
      {
        question: 'productPage.taxAdvice.frequentlyAskedQuestions.faq4',
        answer: 'productPage.taxAdvice.frequentlyAskedQuestions.faqAnswer4'
      }
    ]
  },
  assistance: {
    title: 'productPage.taxAdvice.needAssistance.title',
    getInTouch: 'productPage.taxAdvice.needAssistance.getInTouch',
    actions: 'productPage.taxAdvice.needAssistance.actions'
  },
  getBuyButtonConfig: getTaxAdviceBuyButtonConfig
};
